import React from 'react';
import { FormattedMessage } from "../../../util/reactIntl";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton
} from "react-accessible-accordion";

import css from './SectionFAQAboutHiringOnlineTeachers.module.css';
import { getBullets } from '../../../util/contentful';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { getLetterType } from '../../../util/lettersHelper';

const SectionFAQAboutHiringOnlineTeachers = ({ state, subject, content }) => {
  const items = content && getBullets(content, 'question');

  let article = 'a';
  if(subject) {
    const firstLetterOfCurrentSubject = subject?.label?.substring(0, 1).toLowerCase();
    const letterTypeObject = getLetterType(firstLetterOfCurrentSubject);
    const letterType = letterTypeObject.type;
    article = letterType === 'vowel' ? 'an' : 'a';
  }

  return <div className={css.accordion}>
    <div className={css.rootTitleHolder}>
      <h2 className={css.rootTitle}>
        {content?.faqTitle ?
          content.faqTitle :
          <FormattedMessage
            values={{ state: state?.label || '', subject: subject?.parent || '' }}
            id='SectionFAQAboutHiringOnlineTeachers.title'
          />
        }
      </h2>
    </div>

    <Accordion preExpanded={[1]} key="becomeAHostPageFAQ" allowZeroExpanded >
      {content && items ? Array.from(Array(Object.keys(items).length / 2).keys()).map(i => (
        <AccordionItem uuid={i}>
          <AccordionItemHeading>
            <AccordionItemButton>
              {items[`question${i + 1}Title`]}
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>{documentToReactComponents(items[`question${i + 1}Description`])}</p>
          </AccordionItemPanel>
        </AccordionItem>
      )) : <>
        <AccordionItem uuid={1}>
          <AccordionItemHeading>
            <AccordionItemButton>
              {state && !subject ?
                <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.stateQ1' values={{state: state?.label}} />:
                state && subject ?
                <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.subjectQ1' values={{state: state?.label, subject: subject?.parent}} />:
                <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.q1' />
              }
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              {state && !subject ?
                <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.stateA1' values={{state: state?.label}} />:
                state && subject ?
                  <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.subjectA1' values={{state: state?.label, subject: subject?.parent}} />:
                  <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.a1' />
              }
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem uuid={2}>
          <AccordionItemHeading>
            <AccordionItemButton>
              {state && !subject ?
                <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.stateQ2' values={{state: state?.label}} />:
                state && subject ?
                  <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.subjectQ2' values={{state: state?.label, subject: subject?.parent}} />:
                  <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.q2' />
              }
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              {state && !subject ?
                <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.stateA2' values={{state: state?.label}} />:
                state && subject ?
                  <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.subjectA2' values={{state: state?.label, subject: subject?.parent}} />:
                  <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.a2' />
              }
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem uuid={3}>
          <AccordionItemHeading>
            <AccordionItemButton>
              {state && !subject ?
                <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.stateQ3' values={{state: state?.label}} />:
                state && subject ?
                  <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.subjectQ3' values={{state: state?.label, subject: subject?.parent}} />:
                  <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.q3' />
              }
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              {state && !subject ?
                <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.stateA3' values={{state: state?.label}} />:
                state && subject ?
                  <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.subjectA3' values={{state: state?.label, subject: subject?.parent, article}} />:
                  <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.a3' />
              }
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        {!state && <AccordionItem uuid={4}>
          <AccordionItemHeading>
            <AccordionItemButton>
              {state && !subject ?
                <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.stateQ4'
                                  values={{ state: state?.label }} /> :
                state && subject ?
                  <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.subjectQ4'
                                    values={{ state: state?.label, subject: subject?.parent }} /> :
                  <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.q4' />
              }
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>
              {state && !subject ?
                <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.stateA4'
                                  values={{ state: state?.label }} /> :
                state && subject ?
                  <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.subjectA4'
                                    values={{ state: state?.label, subject: subject?.parent }} /> :
                  <FormattedMessage id='SectionFAQAboutHiringOnlineTeachers.a4' />
              }
            </p>
          </AccordionItemPanel>
        </AccordionItem>}

      </>}
    </Accordion>
  </div>;
};

export default SectionFAQAboutHiringOnlineTeachers;
